import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './GoogleMap.css';

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Custom marker icon with forest theme
const createCustomIcon = () => {
  return L.divIcon({
    className: 'custom-marker',
    html: `
      <div>
        <div>🧘‍♀️</div>
      </div>
    `,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -30]
  });
};

const LeafletMap = () => {
  const position = [19.86631510722008, 75.34184253033385]; // Garkheda, Chhatrapati Sambhajinagar coordinates
  const address = "V88R+GP Garkheda, Chhatrapati Sambhajinagar, Maharashtra, India";


  return (
    <div className="google-map-container">
      <div className="map-header">
      <h4 className="location-text">Our Location</h4>
        <p className="location-text">{address}</p>
      </div>
      <div className="map-wrapper">
        <MapContainer
          center={position}
          zoom={15}
          className="leaflet-map-container"
          scrollWheelZoom={true}
          zoomControl={true}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} icon={createCustomIcon()}>
            <Popup>
              <div className="popup-content">
                <h5>Yogsadhna Varga</h5>
                <p>{address}</p>
                <a 
                  href="https://maps.google.com/?q=19.86631510722008,75.34184253033385" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Open in Google Maps
                </a>
              </div>
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
};

export default LeafletMap;
